import React from "react";
import { useStateValue } from "../../SharedContext";
import { Link } from "@quintype/components";
import get from "lodash.get";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getTextColor, getSlug } from "../../../utils/utils";
import "./load-more.m.css";

export const LoadmoreButtonBase = ({ config, collection, template = "SubsequentLoadCount", onClick }) => {
  const configData = useStateValue() || {};
  const showButton = get(configData, ["showButton"], true);
  const btnText = get(configData, ["buttonText"], "Read More");
  const customUrl = get(configData, ["customUrlPath"], "");
  const textColor = getTextColor(configData.theme);

  const slug = () => {
    if (customUrl) {
      return customUrl;
    } else if (collection) {
      return getSlug(collection, config);
    }
    return "/";
  };

  if (!showButton) return null;

  return template === "SubsequentLoadCount" ? (
    <div className="arr--button" styleName={`button ${textColor} default`} onClick={onClick}>
      {btnText}
    </div>
  ) : (
    <Link href={slug()}>
      <div className="arr--button" styleName={`button ${textColor} default`}>
        {btnText}
      </div>
    </Link>
  );
};

LoadmoreButtonBase.propTypes = {
  collection: PropTypes.object,
  template: PropTypes.string,
  config: PropTypes.object,
  onClick: PropTypes.func
};

function mapStateToProps(state) {
  return {
    config: get(state, ["qt", "config"], {})
  };
}

export const LoadmoreButton = connect(mapStateToProps)(LoadmoreButtonBase);
